(() => {
  const {url: href, band} = document.currentScript.dataset;
  const root = document.getElementById('MainContent');
  if (!root || !href) return;
  const groups = 'fieldset.product-form__controls,.gpo-element,.gpo-field,.globo-form-control';
  const labels = '.gpo-label,.variant-title,label,legend';
  const normalizeLabel = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[＊*:]/g, '').trim().replace(/\s+/g, ' ');
  const isSize = value => /^(?:(?:selecciona|elige) (?:tu |la )?)?(?:(?:la|tu) )?talla(?: (?:del? |para )?(?:anillo|dedo|argolla|ella|el|novia|novio))?$/.test(normalizeLabel(value));
  let link;
  function attach() {
    let sizeLabel;

    for (const group of root.querySelectorAll(groups)) {
      if (!group.querySelector('select,input[type="radio"],input[type="number"],[role="combobox"]')) continue;
      const label = Array.from(group.querySelectorAll(labels)).find(el =>
        el.closest(groups) === group && (isSize(el.textContent) || (band === 'true' && /^(?:talla|medida)\b/.test(normalizeLabel(el.textContent))))
      );
      if (label) { sizeLabel = label; break; }
    }
    const fallback = !sizeLabel && band === 'true'
      ? root.querySelector('product-form.product-form')
      : null;
    if (!sizeLabel && !fallback) return;
    if (!link) {
      link = document.createElement('a');
      link.className = 'pn-size-video-link';
      link.href = href;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.innerHTML = '<span class="pn-size-video-link__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><g transform="rotate(-42 12 12)"><rect x="3" y="8" width="18" height="8" rx="1.4"/><path d="M7 8v4m3-4v2m3-2v4m3-4v2m3-2v4"/></g></svg></span><span>Cómo medir talla</span>';
      link.setAttribute('aria-label', 'Cómo medir talla: ver video en Instagram (abre en otra pestaña)');
    }
    if (sizeLabel) {
      link.removeAttribute('data-fallback');
      if (sizeLabel.nextElementSibling !== link) sizeLabel.insertAdjacentElement('afterend', link);
      if (/^talla (?:del? )?anillo$/.test(normalizeLabel(sizeLabel.textContent)) &&
          !sizeLabel.querySelector('input,select,textarea,button,a,[tabindex],[role="combobox"]')) {
        sizeLabel.classList.add('pn-size-video-label-hidden');
      }
    } else {
      link.setAttribute('data-fallback', '');
      if (fallback.previousElementSibling !== link) fallback.insertAdjacentElement('beforebegin', link);
    }
  }
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; attach(); });
  }).observe(root, {childList:true,subtree:true});
  attach();
})();
